import { useInvoicePaymentDetails } from '@melio/ar-domain';
import { useAnalyticsContext, withAnalyticsContext } from '@melio/platform-analytics';
import { forwardRef } from '@melio/platform-utils';

import { MarkAsPaidFormField } from '../../components';
import { UpdateMarkInvoiceAsPaidScreen } from './screens';

type UpdateMarkInvoiceAsPaidActivityProps = {
  onClose: VoidFunction;
  onDone: VoidFunction;
  isOpen: boolean;
  onError?: ErrorFunction;
  invoiceId: string;
};

const UpdateMarkInvoiceAsPaidInnerActivity = forwardRef<UpdateMarkInvoiceAsPaidActivityProps>(
  ({ onClose, onDone, onError, isOpen, invoiceId, ...props }, ref) => {
    const {
      data: receivablePaymentDetails,
      isFetching,
      isMutating,
      update,
    } = useInvoicePaymentDetails({ id: invoiceId });

    useAnalyticsContext({ globalProperties: { InvoiceId: invoiceId } });

    const handleSubmit = ({ paymentDate, paymentMethod, note, referenceNumber }: MarkAsPaidFormField) => {
      update({
        paidAt: paymentDate,
        method: paymentMethod ? paymentMethod : undefined,
        note,
        referenceNumber,
      })
        .then(onDone)
        .catch(onError);
    };

    return (
      <UpdateMarkInvoiceAsPaidScreen
        onClose={onClose}
        onSubmit={handleSubmit}
        isOpen={isOpen}
        isLoading={isFetching}
        isSaving={isMutating}
        receivablePaymentDetails={receivablePaymentDetails}
        ref={ref}
        {...props}
      />
    );
  }
);

export const UpdateMarkInvoiceAsPaidActivity = withAnalyticsContext(UpdateMarkInvoiceAsPaidInnerActivity);
